module.exports = __webpack_public_path__ + "html/comparison_dd92ebd320e7800c250c1c2282bda0ba.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/comparison.html
// module id = Zx9N
// module chunks = 55